import { resolveVacationPackageIncludedBaggage } from "./resolveVacationPackageIncludedBaggage";

const LS_BAGGAGE_TRACE = "DEBUG_PUBLIC_OFFER_BAGGAGE_DISPLAY";

/** @type {Record<string, string>} */
const _lastTraceFp = Object.create(null);

function _isDev() {
  try {
    return import.meta.env?.DEV === true;
  } catch {
    return false;
  }
}

function _verbose() {
  try {
    return typeof localStorage !== "undefined" && localStorage.getItem(LS_BAGGAGE_TRACE) === "1";
  } catch {
    return false;
  }
}

/**
 * @param {object} payload
 * @param {{ force?: boolean }} [opts]
 */
export function logPublicOfferBaggageDisplayTrace(payload, opts = {}) {
  if (!_isDev() || !payload) return;
  const key = String(payload.packageId ?? "offer");
  const fp = JSON.stringify(payload);
  if (!opts.force && !_verbose() && _lastTraceFp[key] === fp) return;
  _lastTraceFp[key] = fp;
  // eslint-disable-next-line no-console
  console.info("[PUBLIC_OFFER_BAGGAGE_DISPLAY_TRACE]", payload);
}

/**
 * @param {{ selectedResult?: object|null, passengerCount?: number|null, packageId?: string|null }} input
 */
export function buildPublicOfferIncludedBaggageVm(input = {}) {
  const { selectedResult = null, passengerCount = null, packageId = null } = input;
  const resolved = resolveVacationPackageIncludedBaggage(selectedResult);
  const paxN = Number(passengerCount);
  const passengerNote =
    Number.isFinite(paxN) && paxN > 0
      ? `ל-${Math.floor(paxN)} נוסעים`
      : "לכל נוסע בחבילה";

  const items = [];
  if (resolved.carryOnIncluded) {
    items.push({
      key: "carryOn",
      label:
        resolved.carryOnWeightKg != null
          ? `תיק יד / טרולי — ${resolved.carryOnWeightKg} ק"ג`
          : "תיק יד / טרולי כלול",
    });
  }
  if (resolved.checkedBaggageIncluded) {
    items.push({
      key: "checked",
      label:
        resolved.checkedBaggageWeight != null
          ? `מזוודה — ${resolved.checkedBaggageWeight} ק"ג`
          : "מזוודה כלולה",
    });
  }

  const hasIncluded = items.length > 0;

  const vm = {
    hasIncluded,
    items,
    passengerNote,
    summaryLine: hasIncluded
      ? items.map((i) => i.label).join(" · ")
      : null,
    emptyMessage: "כבודה אינה כלולה במחיר החבילה",
    carryOnIncluded: resolved.carryOnIncluded,
    checkedBaggageIncluded: resolved.checkedBaggageIncluded,
    carryOnWeightKg: resolved.carryOnWeightKg ?? null,
    checkedWeightKg: resolved.checkedBaggageWeight ?? null,
    trolleyIncluded: resolved.carryOnIncluded,
    source: resolved.sourcePath ?? "resolveVacationPackageIncludedBaggage",
  };

  logPublicOfferBaggageDisplayTrace({
    packageId,
    carryOnIncluded: vm.carryOnIncluded,
    checkedBaggageIncluded: vm.checkedBaggageIncluded,
    checkedWeight: vm.checkedWeightKg,
    trolleyIncluded: vm.trolleyIncluded,
    source: vm.source,
    passengerCount: Number.isFinite(paxN) ? paxN : null,
    hasIncluded,
  });

  return vm;
}
